import SchedulePickupForm from './SchedulePickupForm';
export default SchedulePickupForm;
